import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SidebarLeftClose.svg",
  "use": "SidebarLeftClose.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"SidebarLeftClose.svg\"><path d=\"M52,52H12a4,4,0,0,1-4-4V16a4,4,0,0,1,4-4H52a4,4,0,0,1,4,4V48A4,4,0,0,1,52,52ZM22,17a1,1,0,0,0-1-1H13a1,1,0,0,0-1,1V47a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1Zm22.011,8.0175a1.0244,1.0244,0,0,0-1.6183-.8189l-9.9483,6.9887a.9971.9971,0,0,0,0,1.6381l9.9483,6.9888a1.0245,1.0245,0,0,0,1.6183-.8191Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol